import { render } from "./DetailData.vue?vue&type=template&id=c5de0fa0&scoped=true"
import script from "./DetailData.vue?vue&type=script&lang=js"
export * from "./DetailData.vue?vue&type=script&lang=js"

import "./DetailData.vue?vue&type=style&index=0&id=c5de0fa0&scoped=true&lang=css"
import "./DetailData.vue?vue&type=style&index=1&id=c5de0fa0&lang=less&scoped=true"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5de0fa0"]])

export default __exports__